import axios from "@/libs/api.request";

export const getList = data => {
    return axios.request({
        url: "main/list",
        method: "post",
        data
    });
};



export const getCategoryList = data => {
    return axios.request({
        url: "main/CategoryList",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data
    });
};

// export const getLinkMan = data => {
//     return axios.request({
//         url: "linkMan/getLinkList",
//         method: "post",
//         data
//     });
// };

export function getUserInfo(params) {
    return axios.request({
        url: "linkMan/getLinkList",
        method: "post",
        params: params
    })
}
export function getLinkMan1(params) {
    return axios.request({
        url: "linkMan/getLinkList",
        method: "post",
        params: params
    })
}
export function sendMail(params) {
    return axios.request({
        url: "Email/getEmailState",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data: params
    })
}

export function getSaler() {
    return axios.request({
        url: "SanmakSaler/getSaler",
        method: "post",
    })
}

export function getWebMenu() {
    return axios.request({
        url: "WebMenu/getWebMenu",
        method: "post",
    })
}

